import React, { Component } from 'react';

import { Suspense } from 'react';

import { Helmet } from 'react-helmet';

import Main from './components/Main';
import Footer from './components/Footer'

import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    localStorage.removeItem('ProfileisOpen');
  }
  render() {
    return (
      <div className="warp-content">
	      
	      <Suspense fallback={(<div>Loading...</div>)}>
		      
	        <Helmet
	          titleTemplate=""
	          defaultTitle="Winvite.io - Conquistando Experiências Unicas">
	          <meta name="description" content="Winvite" />
	        </Helmet>
	
	        <Main />
	       
	        <Footer />
		      
	      </Suspense>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js